import type { LegalDocumentType } from '@/shared/domain'

const STORAGE_KEY = 'accepted_legal_versions'

export type CachedLegalVersions = Partial<Record<LegalDocumentType, string>> & {
  lastChecked?: string
}

export function readCachedVersions(): CachedLegalVersions {
  if (typeof window === 'undefined') return {}
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as CachedLegalVersions
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

export function writeCachedVersions(value: CachedLegalVersions): void {
  if (typeof window === 'undefined') return
  try {
    const previous = readCachedVersions()
    const merged: CachedLegalVersions = {
      ...previous,
      ...value,
      lastChecked: new Date().toISOString(),
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
  } catch {
    return
  }
}
